export default "__VITE_ASSET__606f452d__"